export const RUN_STATUS = Object.freeze({
	IDLE: 'idle',
	RUNNING: 'running',
	WAITING: 'waiting',
	CANCELLED: 'cancelled',
});

export const PHASE = Object.freeze({
	COLLECT: 'collect',
	PLAN: 'plan',
	RUNNING: 'running',
	RESULTS: 'results',
});

export const isWorking = (status) => status === RUN_STATUS.RUNNING || status === RUN_STATUS.WAITING;

export const CONTACT_MODES = Object.freeze([
	{ key: 'none', label: 'Keine Kontakte', short: 'Keine Kontakte' },
	{ key: 'ceo', label: '1 Geschäftsführer je Firma', short: '1 GF je Firma' },
	{ key: 'roles', label: 'Je 1 pro gewählter Rolle', short: 'Je 1 pro Rolle' },
	{ key: 'all', label: 'Alle Ansprechpartner', short: 'Alle Kontakte' },
]);

export const contactModeLabel = (key, field = 'label') =>
	CONTACT_MODES.find((mode) => mode.key === key)?.[field] ?? key;

export const COMPANY_LIMIT = Object.freeze({ min: 1, max: 100 });
export const MAX_PER_COMPANY = Object.freeze({ min: 1, max: 50 });

export const DEFAULT_MANDATE = Object.freeze({
	companyLimit: 25,
	contacts: Object.freeze({ mode: 'none', roles: ['ceo'], maxPerCompany: 10 }),
	contactData: ['email'],
	mapsEnabled: false,
	mapsNationwide: false,
});

export const EXAMPLE_PROMPTS = Object.freeze([
	{
		title: 'CNC-Lohnfertiger im Umkreis von 50 km um Stuttgart',
		subtitle: 'mit mind. 20 Mitarbeitern, je 1 Geschäftsführer als Kontakt',
		text: 'CNC-Lohnfertiger im Umkreis von 50 km um Stuttgart, mit mind. 20 Mitarbeitern, je 1 Geschäftsführer als Kontakt',
	},
	{
		title: 'Hersteller von Reinraumverpackungen in Bayern',
		subtitle: 'die Private Label anbieten',
		text: 'Hersteller von Reinraumverpackungen in Bayern, die Private Label anbieten',
	},
	{
		title: 'Werkzeugbau in NRW, die aktuell Personal suchen',
		subtitle: 'KI prüft die Website je Firma mit Belegstelle',
		text: 'Werkzeugbau in NRW, die aktuell Personal suchen',
	},
]);
